import * as React from 'react';

import VideoCarouselItem from './video-carousel-item';
import { IMediaGalleryItem, IMediaGalleryVideo } from '../classes/media-gallery';

export interface VideoCarouselContainerProps {
    mediaItem: IMediaGalleryItem;
}

const videoCarouselContainer: React.StatelessComponent<VideoCarouselContainerProps> = props => {
    // There's a possibility the item has no image / videos.
    const medias = props.mediaItem.media ? props.mediaItem.media as IMediaGalleryVideo[] : [];

    return (
        <React.Fragment>
            {
                medias.map((video: IMediaGalleryVideo) => <VideoCarouselItem key={video.youtubeId} video={video} />)
            }
        </React.Fragment>
    );
}

export default videoCarouselContainer;


// WEBPACK FOOTER //
// ./app/views/video-carousel.tsx